/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { ANALYZE_FOR_ENTRY_COMPONENTS, Attribute, ContentChild, ContentChildren, Query, ViewChild, ViewChildren } from "./metadata/di";
export { Component, Directive, HostBinding, HostListener, Input, Output, Pipe } from "./metadata/directives";
export { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from "./metadata/ng_module";
export { ViewEncapsulation } from "./metadata/view";
//# sourceMappingURL=metadata.js.map


// WEBPACK FOOTER //
// ../../../packages/core/esm5/src/metadata.js